import { useState } from 'react';
import { Activity, Cloud, Code2, Database } from 'lucide-react';

const colors = {
  navy: '#092952',
  blue: '#0B3B78',
  muted: '#526377',
  border: '#DCE3EC',
};

const toolGroups = [
  { name: 'Cloud platforms', icon: Cloud, tools: ['Amazon Web Services', 'Microsoft Azure', 'Google Cloud', 'Hybrid environments'] },
  { name: 'Infrastructure & delivery', icon: Code2, tools: ['Terraform', 'Ansible', 'GitHub Actions', 'Jenkins', 'GitLab CI/CD'] },
  { name: 'Containers & data', icon: Database, tools: ['Docker', 'Kubernetes', 'Amazon EKS', 'Azure Kubernetes Service', 'Google Kubernetes Engine'] },
  { name: 'Observability & governance', icon: Activity, tools: ['Prometheus', 'Grafana', 'CloudWatch', 'Azure Monitor', 'Cloud cost dashboards'] },
];

function SectionHeading({ title, text, centered = false }) {
  return <div className={centered ? 'cloud-centered mx-auto max-w-6xl text-center' : 'max-w-6xl'}>
    <h2 className="text-[32px] font-semibold leading-[48px]" style={{ color: '#183762' }}>{title}</h2>
    {text && <p className="mt-5 text-base font-normal leading-[27px]" style={{ color: '#212121' }}>{text}</p>}
  </div>;
}

export default function CloudTechnologyStacks() {
  const [activeTools, setActiveTools] = useState(0);
  const toolGroup = toolGroups[activeTools];
  const ToolIcon = toolGroup.icon;
  return (<section className="border-y px-5 py-16 sm:px-6 lg:px-10 lg:py-12" style={{ background: '#FFFFFF', borderColor: colors.border }}>
      <div className="mx-auto max-w-7xl">
        <SectionHeading title="Platforms and tools behind dependable cloud delivery" text="We select technology to fit the workload and your existing environment. Our cloud work spans the following platform and engineering categories." centered />
        <div className="mt-10 grid overflow-hidden md:grid-cols-[minmax(220px,0.85fr)_1.15fr] lg:mt-14" style={{ minHeight: '396px' }}>
          <nav className="overflow-hidden px-5 py-5 sm:px-8 sm:py-7 lg:px-10 lg:py-8" style={{ background: colors.navy }} aria-label="Cloud technology categories">
            <div className="max-h-[330px] overflow-y-auto pr-3 sm:pr-4" style={{ scrollbarColor: '#FFFFFF #48688D', scrollbarWidth: 'thin' }}>
              {toolGroups.map((group, index) => <button key={group.name} type="button" onClick={() => setActiveTools(index)} aria-pressed={activeTools === index} className="flex w-full items-center gap-3 border-b py-4 text-left sm:gap-4 sm:py-5" style={{ borderColor: 'rgba(255,255,255,0.2)', color: activeTools === index ? '#FFFFFF' : 'rgba(255,255,255,0.65)' }}><span className="shrink-0 text-sm font-semibold sm:text-base">{String(index + 1).padStart(2, '0')}.</span><span className="text-sm font-semibold sm:text-base lg:text-lg">{group.name}</span></button>)}
            </div>
          </nav>
          <div className="bg-[#f5f5f5] p-5 sm:p-7 lg:p-8" aria-live="polite">
            <div className="grid gap-3 sm:grid-cols-2 lg:gap-4">
              {toolGroup.tools.map((tool) => <div key={tool} className="flex min-h-[54px] items-center gap-3 border bg-white px-4 py-3 sm:gap-4 sm:px-5" style={{ borderColor: '#D8DEE5' }}><ToolIcon size={25} strokeWidth={1.5} className="shrink-0" style={{ color: colors.blue }} aria-hidden="true" /><span className="text-sm font-medium leading-tight sm:text-base" style={{ color: colors.navy }}>{tool}</span></div>)}
            </div>
          </div>
        </div>
      </div>
    </section>);
}
